import NewsItem from "@/components/pages/MicroSite/Templates/SitecraftTemplate/NewsFeed/NewsItem";
import type { MicroSite } from "@/lib/api";

const NewsFeedGroup = ({data}:{data: MicroSite}) => {
    if(!data){
    return null;
};

  return (
    <div className="flex relative flex-col w-full p-4 lg:p-8 gap-6  justify-center" >
      <div className="grid md:grid-cols-2 lg:grid-cols-3 md:gap-8 gap-6 w-full">
      {Array.isArray(data?.newsFeedSection?.newsFeedSectionDetails) && data.newsFeedSection.newsFeedSectionDetails.map((item, index) => (
          
        <NewsItem key={index} data={item} brandData={data?.branding ?? {}}  />
      ))}
    </div>
    </div>
    
  )
}

export default NewsFeedGroup